import {useState} from 'react'
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import {IconButton} from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

const JoinSection = () => {
    const [value,setValue] = useState(15)
    return (
        <div className="JoinSection" data-aos="fade-up" data-aos-offset="0" data-aos-delay="400">
            <div className="JoinSection-container">
                <div className="join-left text-center">
                    <h3 >JOIN THE 9172</h3>
                    <p>Pre Sale Nov. 2021 | Only 1000 G-Foxes Available | 1.5 SOL</p>
                </div>
                <div className="join-right">
                    <div className="price-wrap">
                    <IconButton className="val-control-btn" onClick={
                        () => {
                            setValue(prev=> prev - 1 > 0?prev - 1 : prev)
                        }
                    }><RemoveCircleOutlineIcon/></IconButton>
                    <input type="text" value={value <10 ? '0' + value : value} readOnly/>
                    <IconButton className="val-control-btn pls" onClick={
                        () => {
                            setValue(prev=> prev + 1)
                        }
                    }><ControlPointIcon/></IconButton>

                    </div>
                    <button className="join-btn">
                        Join &nbsp; <ArrowUpwardIcon style={{transform: "rotate(90deg)"}}/>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default JoinSection
